import React from 'react';
import '../App.css';
import './project1.css';
import './project3.css';
import Sphere from '../images/sphere.mp4'; 
import Phone from '../images/phone.png';
import Screen_shot1 from '../images/malkosculpture_new3.png';
import Comp from '../images/computer_portfolio.png';
import Comp_Screen from '../images/malkosculpture_new.png';
import Phone2 from '../images/holding_phone.png';
import Screen_shot2 from '../images/MalkoScultureScreenshot.png'; 
import Comp2 from '../images/apple.png';
import { useScrollBehavior } from './useScrollBehavior.js';
import Footer from './footer.js' 

const Project3 = () => {

    useScrollBehavior();

    return (
        <div id='project_div1'>
            <div className='module_project' id='project3_moduleOne'>
                <div id='project3_div2'>
                    <video  autoPlay muted loop playsInline preload="auto" crossorigin="anonymous" fetchpriority="high">
                    <source src={Sphere} type="video/mp4" fetchpriority="high"/>
                            Your browser does not support the video tag.
                    </video>
                    <div id='project3_div2_heading_container'>
                    <div id='project_div2_heading1'>
                        <h1> MalkoSculpture</h1>
                    </div>
                    <div id='project_div2_heading2'>
                        <h3>Scope: Website / WebDev, Hosting, Search Engine Optimization</h3>
                        <a className="href_project" href="/">
                        <h3 id='under_construction_p3'>Website: Under Construction</h3></a>
                    </div>
                    
                    <div id='project_div2_heading3'>
                        <p>MalkoSculpture is locally owned and operated sculptore, proudly 
                            creating distinctive, high-quality works for clients throughout 
                            the Sarasota/Tampa area. Specializing in custom sculptures for residential, 
                            commercial, and public spaces and entities, offering expert craftsmanship 
                            in a variety of materials and styles. From concept and design to fabrication 
                            and installation, MalkoSculpture brings artistic vision to life with precision, 
                            creativity, and a dedication to lasting beauty and craftsmanship.</p>
                    </div>
                    </div>
                    <div className="phone-frame_p3">
                        <img src={Phone} alt="Phone Frame" className="frame" />
                        <img src={Screen_shot1} alt="Screen Content" className="screen_project3" />
                    </div>

                    
                </div>
                    
                
            </div>
            <div className='module_project' id='project_moduleTwo'>
                <div id='project_mod2_container'>
                    <div id='project_mod2_inner1'>
                        <h1 id='about_h1'>About the Project</h1>
                        <h1>MalkoSculpture</h1>
                    </div>
                    <div id='project_mod2_inner2'>
                        <p>We brought MalkoSculpture's artistry to the digital stage with a bespoke, 
                            visually rich website designed to echo the elegance of their work. Through 
                            thoughtful SEO and dependable hosting, their creations now reach a wider 
                            audience, inspiring new commissions and deepening their connection with art 
                            lovers. The result is a digital presence as timeless and enduring as the 
                            sculptures themselves.</p>
                    </div>
                </div>

            </div>
            <div className='module_project' id='project_moduleThree'>
                <div id="mod3_container">
                    <div className="frame-container">
                    {/* Computer frame image */}
                        <img src={Comp} alt="Computer Frame" className="computer-frame" />

                        {/* Computer screen content */}
                        <div className="screen-content">
                            <img src={Comp_Screen} alt="Screenshot inside computer screen" />
                        </div>
                    </div>
                </div>
            </div>
            <div className='module_project' id='project_moduleFour'>
                <div id='mod4_container'>
                    
                    <div id='mod4_div2_5'>
                        <div className="frame-container_mod4">
                        {/* Computer frame image */}
                        <img src={Comp2} alt="Computer Frame2" className="computer-frame2" />

                        {/* Computer screen content */}
                        <div className="screen-content2">
                            <img src={Comp_Screen} alt="Screenshot inside computer screen2" />
                        </div>
                    </div>

                    </div>
                    <div id='mod4_div3'>
                        <div className="phone-frame2">
                            <img src={Phone2} alt="Phone Frame2" className="frame2" />
                            <img src={Screen_shot2} alt="Screen Content2" className="screen2" />
                        </div>

                    </div>
                </div>
            </div>
            <Footer/>
            
        </div>
    );
};

export default Project3;